import dayjs from 'dayjs'
import { Result } from 'effect'
import { isNotNullish } from 'effect/Predicate'
import { t } from 'i18next'

import type { RSheetColumn, RSheetRecordNode } from '../../domain/column'

// eslint-disable-next-line complexity,sonarjs/cognitive-complexity
export function validateAndNormalize(
  x: unknown,
  column: RSheetColumn<RSheetRecordNode>,
): Result.Result<unknown, { message: string }> {
  switch (column.type) {
    case 'numeric': {
      if (typeof x === 'number') {
        return Result.succeed(x)
      }
      if (typeof x === 'string') {
        if (x.trim() === '') {
          // 空文字はnullとして扱う（undefinedだと変更が無視されてしまうため）
          return Result.succeed(null)
        }
        // 少なくとも数字が含まれていることは確認する
        if (/\d/v.test(x)) {
          const number = Number(x.replaceAll(',', '').replace('¥', ''))
          if (!Number.isNaN(number)) {
            return Result.succeed(number)
          }
        }
      }

      return Result.fail({
        message: t(`{{target}}は{{title}}に貼り付けできません。`, {
          target: JSON.stringify(x),
          title: column.title ?? '',
        }),
      })
    }
    // eslint-disable-next-line sonarjs/no-duplicated-branches
    case 'integer': {
      if (typeof x === 'number') {
        return Result.succeed(x)
      }
      if (typeof x === 'string') {
        if (x.trim() === '') {
          // 空文字はnullとして扱う（undefinedだと変更が無視されてしまうため）
          return Result.succeed(null)
        }
        // 少なくとも数字が含まれていることは確認する
        if (/\d/v.test(x)) {
          const number = Number(x.replaceAll(',', '').replace('¥', ''))
          if (!Number.isNaN(number)) {
            return Result.succeed(number)
          }
        }
      }

      return Result.fail({
        message: t(`{{target}}は{{title}}に貼り付けできません。`, {
          target: JSON.stringify(x),
          title: column.title ?? '',
        }),
      })
    }
    case 'date': {
      if (typeof x === 'string') {
        const date = dayjs(x)
        if (date.isValid()) {
          return Result.succeed(date.format(`YYYY-MM-DD`))
        }
      }

      return Result.fail({
        message: t(`{{target}}は{{title}}に貼り付けできません。`, {
          target: JSON.stringify(x),
          title: column.title ?? '',
        }),
      })
    }
    case 'datetime': {
      if (typeof x === 'string') {
        const date = dayjs(x)
        if (date.isValid()) {
          return Result.succeed(date.format('YYYY-MM-DDTHH:mm:ss'))
        }
      }

      return Result.fail({
        message: t(`{{target}}は{{title}}に貼り付けできません。`, {
          target: JSON.stringify(x),
          title: column.title ?? '',
        }),
      })
    }
    case 'boolean': {
      if (typeof x === 'boolean') {
        return Result.succeed(x)
      }
      return Result.succeed(isTruthyString(x))
    }
    case 'array': {
      return column.metaType === 'multi_select' && typeof x === 'string'
        ? Result.succeed(x.split(',').map((p) => p.trim()))
        : Result.succeed(x)
    }
    default: {
      break
    }
  }
  return Result.succeed(x)
}

function isTruthyString(x: unknown): boolean {
  if (typeof x === 'string') {
    if (x === '' || x === '0') {
      return false
    }
    return !/false/iv.test(x) // false系の単語以外はすべてtrue扱いにする
  }
  return x !== false && isNotNullish(x)
}
